<template>
  <div>
    <div class="flex-container">
      <div class="steps">
        <div class="title">延期结项评审进度情况</div>
        <el-steps align-center>
          <el-step
            :title="item.name"
            v-for="(item, index) in resultProcessData"
            :key="index"
            :status="
              item.status == 3 || item.status == 4
                ? 'success '
                : item.status == 1
                ? 'process '
                : item.status == 5
                ? 'error '
                : 'wait'
            "
          >
            <template slot="description">
              <span v-if="item.name.indexOf('评审') > -1">
                {{ resultData.finishFlag == "1" ? item.sname : "*" }}
                <br />
                {{ item.bz }}
              </span>
              <span v-if="item.name.indexOf('检查') > -1">
                {{ item.sname }}
                <br />
                {{ item.bz }}
              </span>
            </template>
          </el-step>
        </el-steps>
      </div>
      <div class="table">
        <div class="title">管理组检查情况</div>
        <div>
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            style="
              margin-left: 15px;
              color: #fff;
              background-color: #1c84c6;
              border-color: #1c84c6;
            "
            @click="handleChangeAddDialog"
            :disabled="!isAdd"
            >意见反馈</el-button
          >
        </div>
        <el-table
          :max-height="height"
          :data="glzjcList"
          fit
          highlight-current-row
          :default-sort="{ prop: 'date', order: 'descending' }"
          tooltip-effect="dark"
        >
          <!-- v-if="scope.row.permissions.ischecklist" -->
          <el-table-column
            label="操作"
            align="left"
            min-width="250px"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <el-button
                type="primary"
                @click="jxsqFormDialog = true"
                size="mini"
                v-if="scope.row.permissions.isapplylist"
                >结项申请单</el-button
              >
              <el-button
                type="primary"
                size="mini"
                v-if="scope.row.permissions.isedit"
                @click="handleChangeEditDialog(scope.row)"
                >编辑</el-button
              >
              <el-button
                type="danger"
                @click="delCheckItem(scope.row.feedbackId)"
                v-if="scope.row.permissions.isdel"
                size="mini"
                >删除</el-button
              >
            </template>
          </el-table-column>
          <el-table-column
            label="反馈人"
            align="left"
            prop="ygbh"
            min-width="80px"
            :show-overflow-tooltip="true"
          />

          <el-table-column
            label="反馈时间"
            align="left"
            prop="feedbackTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="意见反馈"
            align="left"
            prop="content"
            min-width="150px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="状态"
            align="left"
            prop="statusName"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="处理人"
            align="left"
            prop="solveBy"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="处理时间"
            align="left"
            prop="solveTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="检查人"
            align="left"
            prop="checkBy"
            min-width="80px"
            :show-overflow-tooltip="true"
          />
          <el-table-column
            label="检查时间"
            align="left"
            prop="checkTime"
            min-width="120px"
            :show-overflow-tooltip="true"
          />
          <template slot="empty">
            <div class="nodata">
              <img src="@/img/nodata.png" alt="" width="160" />
              <div>暂无数据</div>
            </div>
          </template>
        </el-table>
        <div class="table_count">共{{ glzjcList.length }}条记录</div>
      </div>
      <div class="table">
        <div class="title">课题得分情况</div>
        <div>
          <el-table
            :max-height="height"
            v-loading="listLoading"
            :data="resultScoreData"
            fit
            highlight-current-row
            :header-cell-style="tableHeaderColor"
            tooltip-effect="dark"
          >
            <el-table-column
              label="评委姓名"
              prop="judges"
              min-width="110px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.judges }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="评审状态"
              prop="status"
              min-width="100px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.status }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="评审意见"
              prop="psyj"
              :show-overflow-tooltip="true"
              min-width="100px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.psyj }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="提交时间"
              prop="ctime"
              min-width="100px"
              align="left"
              :show-overflow-tooltip="true"
            >
              <template slot-scope="scope">
                <span>{{ scope.row.ctime }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="打分分数"
              prop="total"
              min-width="100px"
              align="left"
            >
              <template slot-scope="scope">
                <span>{{
                  resultData.finishFlag == "1" ? scope.row.total : "*"
                }}</span>
              </template>
            </el-table-column>
            <template slot="empty">
              <div class="nodata">
                <img src="@/img/nodata.png" alt="" width="160" />
                <div>暂无数据</div>
              </div>
            </template>
          </el-table>
        </div>
      </div>
      <div class="result" v-if="resultData.finishFlag == '1'">
        <div class="title">课题获奖情况</div>
        <div class="card apply-info">
          <div class="item">
            <div style="color: #000; font-weight: 800">
              课题获得奖项：{{ resultData.prize }}
            </div>
          </div>
          <div class="item">
            <div style="color: #000; font-weight: 800">
              课题获奖金额：{{ resultData.money }}
            </div>
          </div>
        </div>
      </div>
      <div class="result">
        <div class="title">评委评审结果和意见反馈</div>
        <div>
          <div>
            <el-tabs>
              <el-tab-pane
                v-for="(it, index) in resultJudges"
                :label="it.judges"
                :key="index"
              >
                <div class="result_content" v-html="it.feedback"></div>
                <div
                  class="result_content"
                  v-for="(item, index2) in resultDetailsData"
                  :key="index2"
                >
                  <div v-if="it.judges == item.judges">
                    <div class="label">
                      <span v-if="item.required == '1'" class="red">*</span>
                      <span>{{ item.stype }}</span>
                    </div>
                    <div class="text">
                      <div v-html="item.reference"></div>
                    </div>
                    <div style="padding: 0 15px 15px 15px">
                      <div style="color: #000; font-weight: 700">
                        {{ item.scoring_criteria }}
                      </div>
                      <div class="content_text">
                        评委打分：
                        <label style="color: red">{{
                          resultData.finishFlag == "1" ? item.score + "分" : "*"
                        }}</label>
                      </div>
                    </div>
                  </div>
                </div>
              </el-tab-pane>
            </el-tabs>
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      title="添加意见反馈"
      :visible.sync="addAdviceDialog"
      append-to-body
      width="900px"
      v-if="addAdviceDialog"
      :closeOnClickModal="false"
    >
      <el-input
        type="textarea"
        :autosize="{ minRows: 6, maxRows: 12 }"
        maxlength="3000"
        show-word-limit
        placeholder="请输入意见反馈"
      />
      <span slot="footer" class="dialog-footer">
        <el-button @click="addAdviceDialog = false">取 消</el-button>
        <el-button type="primary" @click="addAdviceDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="编辑意见反馈"
      :visible.sync="editAdviceDialog"
      width="900px"
      append-to-body
      v-if="editAdviceDialog"
      :closeOnClickModal="false"
    >
      <div style="margin-bottom: 15px">
        <span style="margin-right: 30px">状态：</span>
        <el-radio-group v-model="editform.status">
          <el-radio label="1">待修改</el-radio>
          <el-radio label="2">修改通过</el-radio>
        </el-radio-group>
      </div>
      <div>
        <div style="margin-bottom: 15px">意见反馈：</div>
        <el-input
          type="textarea"
          :autosize="{ minRows: 6, maxRows: 12 }"
          maxlength="3000"
          show-word-limit
          placeholder="请输入意见反馈"
        />
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="editAdviceDialog = false">取 消</el-button>
        <el-button type="primary" @click="editAdviceDialog = false"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <div v-show="addAdviceDialog">
      <el-dialog
        title="意见反馈"
        :visible.sync="addAdviceDialog"
        append-to-body
        width="900px"
        :closeOnClickModal="false"
      >
        <div style="display: flex" v-if="feedbackId">
          <span style="width: 72px; text-align: right; margin-right: 15px">
            状态
            <span style="color: #ff0000">*</span>:
          </span>
          <span>
            <el-radio-group v-model="addAdviceForm.status">
              <el-radio label="1">待修改</el-radio>
              <el-radio label="3">修改通过</el-radio>
            </el-radio-group>
          </span>
        </div>
        <div style="line-height: 44px">
          意见反馈
          <span style="color: #ff0000">*</span> ：
        </div>
        <el-input
          type="textarea"
          v-model="addAdviceForm.content"
          :autosize="{ minRows: 6, maxRows: 12 }"
          maxlength="3000"
          show-word-limit
          placeholder="请输入意见反馈"
        />
        <span slot="footer" class="dialog-footer">
          <el-button @click="addAdviceDialog = false">取 消</el-button>
          <el-button type="primary" @click="addAdvice">确 定</el-button>
        </span>
      </el-dialog>
    </div>
    <el-dialog
      title="结项申请"
      :visible.sync="jxsqFormDialog"
      width="90%"
      v-if="jxsqFormDialog"
      append-to-body
      :closeOnClickModal="false"
    >
      <JxsqForm
        :mxParams="mxParams"
        ref="jxsqForm"
        @getParentForm="getList"
      ></JxsqForm>
      <span slot="footer" class="dialog-footer">
        <el-button @click="jxsqFormDialog = false">取 消</el-button>
        <el-button type="primary" @click="saveJxsqForm">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { formatMomentDate } from "@/utils/utils";
import moment from "moment";
import "moment/locale/zh-cn";
import { mapGetters } from "vuex";
import {
  getCourseClosingResult,
  getListAllFeedback,
  insertClosingFeedback,
} from "@/api/course.js";
import JxsqForm from "../courseJxsqForm/jxsqForm.vue";

export default {
  name: "courseYqjxps",
  computed: { ...mapGetters(["course", "user"]) },
  props: ["mxParams", "course"],
  components: { JxsqForm },
  data() {
    return {
      height: 500,
      glzjcList: [], //管理组检查表
      addAdviceDialog: false,
      editAdviceDialog: false,
      jxsqFormDialog: false,
      isEdit: false,
      editform: { status: "1" },
      stepsList: [],
      addAdviceForm: {
        status: "1",
        content: null,
      },
      isAdd: true,
      feedbackId: null,
      resultProcessData: [],
      resultDetailsData: [],
      resultScoreData: [],
      resultJudges: [],
      resultData: {
        linkId: null,
        cid: "",
        isxs: null,
        money: "",
        prize: "",
      },
    };
  },

  created() {
    if (
      !this.course.courseFeedbackInfo ||
      this.course.courseFeedbackInfo.length == 0
    ) {
      this.$store.dispatch("course/fetchInspectionAction", {
        courseId: this.mxParams.id,
      });
    }

    //评委委员
    const params = {
      cid: this.mxParams.id,
      step: 13,
      times: 2,
      group: this.mxParams.group,
    };
    getCourseClosingResult(params).then((res) => {
      if (res.code === 0) {
        this.resultProcessData = res.data.process;
        this.resultDetailsData = res.data.details;
        this.resultScoreData = res.data.score;
        this.resultData.linkId = res.data.linkid;
        this.resultData.cid = res.data.cid;
        this.resultData.isxs = res.data.isxs;
        this.resultData.money = res.data.money;
        this.resultData.prize = res.data.prize;
        this.resultData.finishFlag = res.data.finishFlag;
        this.resultJudges = res.data.judges;
        this.fetchListAllFeedback();
      }
    });
  },
  mounted() {},
  methods: {
    toApplyForm(id) {},
    // 管理组检查情况
    fetchListAllFeedback() {
      getListAllFeedback({
        courseId: this.mxParams.id,
        step: 12,
        linkId: this.resultData.linkId,
      }).then((res) => {
        if (res.code == 0) {
          this.glzjcList = res.data.courseFeedbackInfo;
          this.isAdd = res.data.isAdd == 1 ? true : false;
        }
      });
    },
    //删除管理组检查情况
    delCheckItem(feedbackId) {
      deleteInspection({ feedbackId }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.fetchListAllFeedback();
        }
      });
    },
    handleChangeAddDialog() {
      this.addAdviceDialog = true;
      this.addAdviceForm = {
        status: "1",
        content: null,
      };
    },
    handleChangeEditDialog(row) {
      this.addAdviceForm = {
        status: row.status,
        content: row.content,
      };
      this.feedbackId = row.feedbackId;
      this.addAdviceDialog = true;
    },
    addAdvice() {
      if (!this.addAdviceForm.status) {
        this.$message.error("状态不能为空！");
        return;
      }
      if (!this.addAdviceForm.content) {
        this.$message.error("意见反馈不能为空！");
        return;
      }
      insertClosingFeedback({
        ...this.addAdviceForm,
        courseId: this.mxParams.id,
        linkId: this.resultData.linkId,
        step: "12",
        ygbh: this.user.ygbh,
        feedbackId: this.feedbackId,
      }).then((res) => {
        if (res.code == 0) {
          this.$message.success(res.msg);
          this.addAdviceDialog = false;
          this.feedbackId = null;
          this.addAdviceForm = {
            status: "1",
            content: null,
          };
          this.fetchListAllFeedback();
        } else {
          this.$message.error(res.msg);
        }
      });
      // if (this.feedbackId) {
      //   editFeedback({
      //     step: "12",
      //     courseId: this.mxParams.id,
      //     content: this.addAdviceForm.content,
      //     status: this.addAdviceForm.status,
      //     feedbackId: this.feedbackId
      //   }).then(res => {
      //     if (res.code == 0) {
      //       this.$message.success(res.msg);
      //       this.addAdviceDialog = false;
      //       this.feedbackId = null;
      //       this.fetchListAllFeedback();
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
      // } else {
      //   insertFeedback({
      //     linkId: this.resultData.linkId,
      //     status: "1",
      //     step: "12",
      //     content: this.addAdviceForm.content,
      //     courseId: this.mxParams.id
      //   }).then(res => {
      //     if (res.code == 0) {
      //       this.$message.success(res.msg);
      //       this.addAdviceDialog = false;
      //       this.fetchListAllFeedback();
      //     } else {
      //       this.$message.error(res.msg);
      //     }
      //   });
      // }
    },
    saveJxsqForm() {
      this.$refs.jxsqForm.saveForm();
    },
    getList() {
      this.jxsqFormDialog = false;
      this.fetchListAllFeedback();
    },
  },
};
</script>
<style lang="less" scoped>
.flex-container {
  width: 100%;
  height: 100%;
}
.tips {
  background-color: #d7d7d7;
  height: 44px;
  line-height: 44px;
  padding-left: 15px;
  margin: 15px 0;
}
.title {
  font-size: 15px;
  font-weight: bold;
  padding-left: 15px;
  line-height: 42px;
  height: 42px;
  border-bottom: 1px solid #ddd;
  margin-bottom: 15px;
}
.table_count {
  color: #666;
  margin: 10px 15px;
}
.apply-info {
  display: flex;
  height: 44px;
  line-height: 44px;
  .item {
    padding: 0 50px;
  }
  div {
    display: flex;
  }
}
.result {
  font-size: 14px;
  .result_detail {
    color: #666;
    line-height: 32px;
    padding: 0 15px;
    .advice {
      background: #f3f3f3;
      color: #666;
      padding-left: 10px;
    }
  }
}
.result_content {
  border: 1px solid #ddd;
  line-height: 32px;
  .label {
    line-height: 42px;
    font-size: 16px;
    background-color: #f3f3f3;
    padding-left: 15px;
  }
  .text {
    padding: 15px;
  }
}
</style>